/**
 * Текст отказа для человека.
 *
 * Сервер присылает доменную ошибку кодом и сообщением («кабинет с кодом 'ls'
 * уже есть»), и показывать надо именно его: «Произошла ошибка» не говорит, что
 * делать дальше. Сюда же сводится случай, когда до сервера не дошли вовсе.
 */

export function errorText(error: unknown): string | undefined {
  if (error === null || error === undefined) return undefined;
  if (error instanceof Error && error.message !== '') return error.message;
  return 'Запрос не дошёл до сервера. Проверьте связь и повторите';
}
